import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/src/app/partnership-opportunities/layout.tsx");
